import axios from 'axios';

const panditAxios = axios.create({
  baseURL: process.env.REACT_APP_PANDIT_SERVICE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Internal-Secret': process.env.REACT_APP_PANDIT_INTERNAL_SECRET,
  },
});

const PanditApiService = {
  get: async (url) => {
    const res = await panditAxios.get(url);
    return res.data;
  },
  post: async (url, data) => {
    const res = await panditAxios.post(url, data);
    return res.data;
  },
  patch: async (url, data) => {
    const res = await panditAxios.patch(url, data);
    return res.data;
  },
};

export default PanditApiService;
